import { Injectable } from '@angular/core';
import { subscribeOn, filter, map } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UiEventService {

  private event$ = new Subject<any>();

  constructor() { }

  event(eventName) {
    return this.event$.pipe(filter(e => e.name == eventName)).pipe(map(e => e.args));
  }

  publish (eventName, args)
  {
    var e = {
      name : eventName,
      args : args
    };

    this.event$.next(e);
  }
}
